/*
 * NutriProVita hero — App.tsx.
 * Mobile (<768px): 16/9 crossfade, glass prev/next arrows, thumb strip.
 * Desktop (>=768px): "peek carousel" — active slide centred, prev/next peeking
 * blurred at the edges (data-offset -1 / 0 / 1 / hidden), dot indicators.
 * The visible/hidden state per breakpoint is CSS; this only maintains
 * `.is-active` (crossfade + thumbs + dots) and `data-offset` (the deck).
 * Autoplay every 6.5s, pauses on hover. No dependencies.
 */
class NpvHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.npv-hero__slide'));
    this.thumbs = Array.from(this.querySelectorAll('.npv-hero__thumb'));
    this.dots = Array.from(this.querySelectorAll('.npv-hero__dot'));
    this.index = 0;
    this.count = this.slides.length;
    if (this.count < 2) return;

    this.thumbs.forEach((el, i) => el.addEventListener('click', () => this.go(i)));
    this.dots.forEach((el, i) => el.addEventListener('click', () => this.go(i)));

    // Desktop: clicking a peeking (non-active) card advances to it.
    // A slide may be an <a> to a promoted product/collection. Clicking a
    // NON-active (peeking) slide advances the deck instead of navigating;
    // the active slide's link works normally.
    this.slides.forEach((el, i) =>
      el.addEventListener('click', (e) => {
        if (i !== this.index) {
          e.preventDefault();
          this.go(i);
        }
      })
    );

    this.render();
    this.start();
    this.addEventListener('pointerenter', () => this.stop());
    this.addEventListener('pointerleave', () => this.start());
  }

  disconnectedCallback() {
    this.stop();
  }

  start() {
    this.stop();
    this.timer = setInterval(() => this.go(this.index + 1), 6500);
  }

  stop() {
    clearInterval(this.timer);
  }

  go(next) {
    this.index = ((next % this.count) + this.count) % this.count;
    this.render();
  }

  render() {
    const n = this.count;
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.index);
      // Deck offset: shortest signed distance from the active index, wrapped.
      let offset = ((i - this.index) % n + n) % n;
      if (offset > Math.floor(n / 2)) offset -= n;
      slide.dataset.offset = Math.abs(offset) > 1 ? 'hidden' : String(offset);
    });
    this.thumbs.forEach((thumb, i) => {
      const on = i === this.index;
      thumb.classList.toggle('is-active', on);
      thumb.setAttribute('aria-current', on ? 'true' : 'false');
    });
    this.dots.forEach((dot, i) => {
      const on = i === this.index;
      dot.classList.toggle('is-active', on);
      dot.setAttribute('aria-current', on ? 'true' : 'false');
    });
  }
}

if (!customElements.get('npv-hero')) {
  customElements.define('npv-hero', NpvHero);
}
